import React from 'react';
import classNames from 'classnames/bind';
import { IconArrowsLeft, IconArrowsRight } from '@carnica/graphics';
import { enhancedConnect } from "../../../utils";
import styles from "./styles.pcss";
import { useCarouselNavigationButtons } from "./useCarouselNavigationButtons";
var cx = classNames.bind(styles);
var _CarouselNavigationButtons = function _CarouselNavigationButtons(_ref) {
  var className = _ref.className,
    backgroundColor = _ref.backgroundColor,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'primary' : _ref$type;
  var _useCarouselNavigatio = useCarouselNavigationButtons(),
    isPrevBtnEnable = _useCarouselNavigatio.isPrevBtnEnable,
    isNextBtnEnable = _useCarouselNavigatio.isNextBtnEnable,
    handlePrevSlide = _useCarouselNavigatio.handlePrevSlide,
    handleNextSlide = _useCarouselNavigatio.handleNextSlide;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('navigation', type, className),
    "data-t-id": "Carousel-CarouselNavigationButtons"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": "\u043F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439 \u0441\u043B\u0430\u0439\u0434",
    className: cx('navigation-btn', {
      'navigation-btn--disable': !isPrevBtnEnable
    }),
    onClick: handlePrevSlide,
    style: {
      backgroundColor: backgroundColor
    },
    type: "button"
  }, /*#__PURE__*/React.createElement(IconArrowsLeft, {
    className: cx('navigation-icon'),
    size: 24
  })), /*#__PURE__*/React.createElement("button", {
    "aria-label": "\u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0441\u043B\u0430\u0439\u0434",
    className: cx('navigation-btn', {
      'navigation-btn--disable': !isNextBtnEnable
    }),
    onClick: handleNextSlide,
    style: {
      backgroundColor: backgroundColor
    },
    type: "button"
  }, /*#__PURE__*/React.createElement(IconArrowsRight, {
    className: cx('navigation-icon'),
    size: 24
  })));
};
export var CarouselNavigationButtons = enhancedConnect()(_CarouselNavigationButtons);